import { Field } from '@shopify/react-form';
import toNumber from 'lodash/toNumber';
import Text14 from '@sdk/components/ui/typography/Text14';
import displayNumberOrReplacer from '@sdk/utils/displayNumberOrReplacer';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import gettext, { npgettext } from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

type Props = {
  breakDuration: Field<string>;
  breakThreshold: Field<string>;
};

const AutomationRuleSummary = ({ breakDuration, breakThreshold }: Props) => {
  const breakMinutes = breakDuration.value || 0;
  const breakThresholdHours = breakThreshold.value || 0;

  return (
    <Text14 themeColor={ThemeColorType.gray}>
      <TranslateWithComponents
        replaceComponents={{
          breakDuration: (
            <Text14 themeColor={ThemeColorType.primary}>
              {displayNumberOrReplacer(breakDuration.value, 'X')}
            </Text14>
          ),
          breakThreshold: (
            <Text14 themeColor={ThemeColorType.primary}>
              {displayNumberOrReplacer(breakThresholdHours, 'X')}
            </Text14>
          ),
        }}>
        {gettext(
          'Employees get [[breakDuration]] %(minutes)s every [[breakThreshold]] %(hours)s they work.',
          {
            minutes: npgettext(
              'i.e. Employees get 10 minutes',
              'minute',
              'minutes',
              toNumber(breakMinutes),
              {
                breakMinutes,
              }
            ),
            hours: npgettext(
              'i.e. Every 10 hours',
              'hour',
              'hours',
              toNumber(breakThresholdHours),
              {
                breakThresholdHours,
              }
            ),
          }
        )}
      </TranslateWithComponents>
    </Text14>
  );
};

export default AutomationRuleSummary;
